import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBusinessCardRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27.2 7.2c.44 0 .8.36.8.8v16c0 .44-.36.8-.8.8H4.8c-.44 0-.8-.36-.8-.8V8c0-.44.36-.8.8-.8zM4.8 4.8A3.203 3.203 0 0 0 1.6 8v16c0 1.765 1.435 3.2 3.2 3.2h22.4c1.765 0 3.2-1.435 3.2-3.2V8c0-1.765-1.435-3.2-3.2-3.2zM12 15.6c1.545 0 2.8-1.255 2.8-2.8S13.545 10 12 10a2.8 2.8 0 0 0-2.8 2.8c0 1.545 1.255 2.8 2.8 2.8m-1.6 2c-2.21 0-4 1.79-4 4 0 .44.36.8.8.8h9.6c.44 0 .8-.36.8-.8 0-2.21-1.79-4-4-4zm10-7.2c-.665 0-1.2.535-1.2 1.2s.535 1.2 1.2 1.2h4c.665 0 1.2-.535 1.2-1.2s-.535-1.2-1.2-1.2zm0 4.8c-.665 0-1.2.535-1.2 1.2s.535 1.2 1.2 1.2h4c.665 0 1.2-.535 1.2-1.2s-.535-1.2-1.2-1.2z" })
});
export default SvgBusinessCardRegularIcon;
